/** Categorías y factores de conversión de unidades. */
export const CATEGORIAS_MEDIDA = {
  length: {
    name: "Longitud",
    baseUnit: "m",
    units: [
      { value: "mm", label: "Milímetros (mm)", factor: 0.001 },
      { value: "cm", label: "Centímetros (cm)", factor: 0.01 },
      { value: "m", label: "Metros (m)", factor: 1 },
      { value: "km", label: "Kilómetros (km)", factor: 1000 },
      { value: "in", label: "Pulgadas (in)", factor: 0.0254 },
      { value: "ft", label: "Pies (ft)", factor: 0.3048 },
      { value: "yd", label: "Yardas (yd)", factor: 0.9144 },
      { value: "mi", label: "Millas (mi)", factor: 1609.344 },
    ],
  },
  weight: {
    name: "Masa / Peso",
    baseUnit: "g",
    units: [
      { value: "mg", label: "Miligramos (mg)", factor: 0.001 },
      { value: "g", label: "Gramos (g)", factor: 1 },
      { value: "kg", label: "Kilogramos (kg)", factor: 1000 },
      { value: "oz", label: "Onzas (oz)", factor: 28.349523125 },
      { value: "lb", label: "Libras (lb)", factor: 453.59237 },
      { value: "ton", label: "Toneladas métricas (t)", factor: 1e6 },
    ],
  },
  volume: {
    name: "Volumen",
    baseUnit: "l",
    units: [
      { value: "ml", label: "Mililitros (ml)", factor: 0.001 },
      { value: "l", label: "Litros (L)", factor: 1 },
      { value: "cup", label: "Tazas (cup)", factor: 0.236588 },
      { value: "gal", label: "Galones (gal)", factor: 3.78541 },
      { value: "oz_fl", label: "Onzas líquidas (fl oz)", factor: 0.0295735 },
    ],
  },
  area: {
    name: "Área / Superficie",
    baseUnit: "m2",
    units: [
      { value: "cm2", label: "Centímetros² (cm²)", factor: 0.0001 },
      { value: "m2", label: "Metros² (m²)", factor: 1 },
      { value: "ha", label: "Hectáreas (ha)", factor: 10000 },
      { value: "km2", label: "Kilómetros² (km²)", factor: 1e6 },
      { value: "ft2", label: "Pies² (ft²)", factor: 0.09290304 },
      { value: "acre", label: "Acres", factor: 4046.8564224 },
    ],
  },
  temp: {
    name: "Temperatura",
    baseUnit: "°C",
    units: [
      { value: "°C", label: "Celsius (°C)" },
      { value: "°F", label: "Fahrenheit (°F)" },
      { value: "K", label: "Kelvin (K)" },
    ],
  },
};
